// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af59b111","455":"e3aed732","977":"a7429fca"}[chunkId] + ".chunk.js";
};